if (!customElements.get("predictive-search")) {
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.showModal = false;
      this.input = this.querySelector("input#search");
      this.predictiveSearchModal = this.querySelector("[data-psearch-modal]");
      this.searchHeader = this.querySelector("[data-psearch-header]");
      this.emptyResults = this.querySelector("[data-psearch-no-results]");
      this.moreResultsLink = this.querySelector("[data-psearch-more-results]");

      this.productsContainer = this.querySelector(
        "[data-psearch-products-container]"
      );
      this.suggestionsContainer = this.querySelector(
        "[data-psearch-suggestions-container]"
      );
      this.productsList = this.querySelector("[data-psearch-products-list]");
      this.suggestionsList = this.querySelector(
        "[data-psearch-suggestions-list]"
      );
      this.productsEmpty = this.querySelector("[data-psearch-no-products]");
      this.suggestionsEmpty = this.querySelector(
        "[data-psearch-suggestions-empty]"
      );

      this.input?.addEventListener(
        "input",
        this.debounce((event) => {
          //Don't run predictive-search if the searchbar is using Nosto
          if (this.input.hasAttribute("data-nosto-element")) {
            return;
          }

          this.onChange(event);
        }, 300).bind(this)
      );

      // Close search results if user clicks outside of modal or search bar
      document.addEventListener("click", (event) => {
        const target = event.target;

        if (
          !this.showModal ||
          elementOrAncestorHasClass(target, [
            "predictive-search-modal",
            "search-form",
          ])
        ) {
          return;
        }
        this.close();
      });
    }

    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }

    setModalWidth() {
      if (!this.predictiveSearchModal) {
        return;
      }

      const modal = this.predictiveSearchModal;
      const modalRect = modal.getBoundingClientRect();
      const modalParent = modal.parentElement;

      if (window.innerWidth <= 650) {
        modal.style.width = null;
        return;
      }

      // Set modal alignment based on if the parent is closer to the left or right side of the window
      let alignment =
        modalParent.getBoundingClientRect().left +
          modalParent.getBoundingClientRect().width / 2 <=
        window.innerWidth / 2
          ? "left"
          : "right";
      const updatedWidth =
        alignment === "left"
          ? window.innerWidth - modalRect.left
          : modalRect.left + modalRect.width;

      modal.style.width = `${updatedWidth}px`;
    }

    onChange() {
      const searchTerm = this.input.value.trim();

      if (!searchTerm.length) {
        this.close();
        return;
      }

      this.getSearchResults(searchTerm);
    }

    getSearchResults(searchTerm) {
      fetch(
        `${window.routes.predictive_search_url}.json?q=${searchTerm}&resources[type]=product,page,article,collection&resources[fields]=title,product_type,variants.title,variants.sku,vendor`
      )
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }

          return response.json();
        })
        .then((data) => {
          this.renderResults(searchTerm, data);
        })
        .catch((error) => {
          this.close();
          const toast = document.querySelector("toast-alert");
          if (toast) {
            toast.addMessage({
              type: "error",
              text: error,
            });
          }
        });
    }
    open() {
      if (!this.showModal) {
        document
          .querySelectorAll("[data-mobile-search-trigger]")
          ?.forEach((trigger) => trigger.classList.add("disable-trigger"));
        this.setModalWidth();
        this.predictiveSearchModal.style.display = "block";
        this.showModal = true;
      }
    }

    close() {
      if (this.showModal) {
        document
          .querySelectorAll("[data-mobile-search-trigger]")
          ?.forEach((trigger) => trigger.classList.remove("disable-trigger"));
        this.predictiveSearchModal.style.display = "none";
        this.productsList.innerHTML = "";
        this.suggestionsList.innerHTML = "";
        this.productsEmpty.innerText = "";
        this.suggestionsEmpty.innerText;
        this.searchHeader.innerText = "";
        this.showModal = false;
      }
    }

    maxResults() {
      return window.innerWidth <= 650 ? 4 : 8;
    }

    renderResults(searchTerm, response) {
      const searchResults = response?.resources?.results;
      const prefix = encodeURIComponent("options[prefix]");
      const searchTermEncoded = encodeURIComponent(searchTerm);
      const moreResultsHref = `/search?${prefix}=last&q=${searchTermEncoded}`;

      this.searchHeader.innerText = `"${searchTerm}"`;
      this.moreResultsLink.setAttribute("href", moreResultsHref);

      //Map Products
      const searchProducts =
        !searchResults?.products || searchResults?.products?.length === 0
          ? []
          : searchResults.products
              .slice(0, this.maxResults() - 1)
              .map((product) => this.mapProductJSON(product));

      //Map suggestions
      let suggestions = [];

      if (searchResults?.articles) {
        suggestions = [...suggestions, ...searchResults.articles];
      }
      if (searchResults?.collections) {
        suggestions = [...suggestions, ...searchResults.collections];
      }
      if (searchResults?.pages) {
        suggestions = [...suggestions, ...searchResults.pages];
      }
      suggestions = suggestions.slice(0, this.maxResults() - 1);

      //Render Lists
      if (searchProducts?.length > 0 || suggestions.length > 0) {
        this.emptyResults.innerHTML = "";
        this.emptyResults.style.display = "none";
        this.productsContainer.style.display = "block";

        if (searchProducts?.length > 0) {
          this.emptyResults.style.display = "none";
          searchProducts.forEach((product) => {
            const listItemHTML = `
                <div class="predictive-search__products-list-item">
                    <a class="predictive-search__product-link" href="${
                      product.url
                    }">
                        <a href="${product.url}" id="${
              product.id
            }" tabindex="0" aria-live="polite" class="product-tile link-text" widget="true">
                            <div class="product-tile__images">
                                <div>
                                    ${
                                      product.image
                                        ? `<img src="${product.image}" alt="${product.title}" loading="lazy" class="product-tile__img-main" height="57" width="57" />`
                                        : `<svg class="product-tile__img-main product-tile__img-main--placeholder" viewBox="0 0 350 465" width="100%">
                                            <rect x="0" y="0" width="100%" height="100%"></rect>
                                        </svg>`
                                    }
                                    
                                </div>
                            </div>
                            <div class="product-tile__static-text-content">
                                <div class="row">
                                    <div class="product-tile__vendor">
                                        ${product.vendor}
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="product-tile__title">
                                        <div class="product-tile-title">
                                            ${product.title}
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="product-tile__price-container">
                                        <span class="product-tile__price">
                                            <span class="visually-hidden">Now: </span>
                                            ${this.moneyWithoutDecimals(
                                              product.price
                                            )}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </a>
                </div>
              `;
            this.productsList.insertAdjacentHTML("beforeend", listItemHTML);
          });
          const listItemMoreResults = `
            <div class="predictive-search__products-list-item predictive-search__products-list-item--link">
                <a class="link predictive-search__products-list-item-more-result more-result" href="${moreResultsHref}">More results</a>
            </div>
            `;
          if (window.innerWidth <= 650) {
            this.productsList.insertAdjacentHTML(
              "beforeend",
              listItemMoreResults
            );
          }
        } else {
          this.productsEmpty.innerText = `There are no products for "${searchTerm}"`;
          this.productsEmpty.style.display = "block";
        }

        this.suggestionsContainer.style.display = "block";

        if (suggestions.length > 0) {
          this.suggestionsEmpty.style.display = "none";
          this.suggestionsEmpty.innerText = "";
          this.suggestionsList.style.display = "block";
          this.suggestionsList.innerHTML = "";

          suggestions.forEach((suggestion) => {
            const listItemHTML = `
                <div class="predictive-search__suggestions-list-item">
                    <a class="predictive-search__suggestions-list-item--textlink" href="${suggestion.url}">
                        ${suggestion.title}
                    </a>
                </div>
            `;
            this.suggestionsList.insertAdjacentHTML("beforeend", listItemHTML);
          });

          const listItemMoreResults = `
          <div class="predictive-search__suggestions-list-item predictive-search__suggestions-list-item--link">
              <a class="link predictive-search__products-list-item-more-result suggestion-more-result more-result link link--primary" href="${moreResultsHref}"><span>More Results</span></a>
          </div>
      `;
          if (window.innerWidth <= 650) {
            this.suggestionsList.insertAdjacentHTML(
              "beforeend",
              listItemMoreResults
            );
          }
        } else {
          this.suggestionsEmpty.innerText = `There are no suggestions for ${searchTerm}`;
          this.suggestionsEmpty.style.display = "block";
          this.suggestionsList.style.display = "none";
        }
      } else {
        this.productsContainer.style.display = "none";
        this.suggestionsContainer.style.display = "none";
        this.emptyResults.innerHTML = `There are no results for "${searchTerm}"`;
        this.emptyResults.style.display = "block";
      }
      this.open();
    }

    mapProductJSON(product) {
      const productJSON = {
        ...product,
        compare_at_price: product.compare_at_price_min
          ? this.stringPriceToInt(product.compare_at_price_min)
          : product.compare_at_price_min,
        compare_at_price_max: product.compare_at_price_max
          ? this.stringPriceToInt(product.compare_at_price_max)
          : product.compare_at_price_max,
        compare_at_price_min: product.compare_at_price_min
          ? this.stringPriceToInt(product.compare_at_price_min)
          : product.compare_at_price_min,
        price: product.price
          ? this.stringPriceToInt(product.price)
          : product.price,
        price_max: product.price_max
          ? this.stringPriceToInt(product.price_max)
          : product.price_max,
        price_min: product.price_min
          ? this.stringPriceToInt(product.price_min)
          : product.price_min,
        variants:
          product.variants.length > 0
            ? product.variants.map((variant) => {
                return {
                  ...variant,
                  image: {
                    ...variant.featured_image,
                    src: variant.featured_image.url,
                  },
                  compare_at_price: variant.compare_at_price
                    ? this.stringPriceToInt(variant.compare_at_price)
                    : variant.compare_at_price,
                  price: variant.price
                    ? this.stringPriceToInt(variant.price)
                    : variant.price,
                };
              })
            : [],
      };

      productJSON.featured_image = productJSON.featured_image || {};
      productJSON.featured_image.src = productJSON.featured_image.url;
      productJSON.images = [productJSON.featured_image];

      if (product.variants.length <= 0) {
        const variant = {
          ...productJSON,
          image: { ...productJSON.featured_image },
        };
        productJSON.variants = [variant];
      }

      productJSON.selected_or_first_available_variant = productJSON.variants[0];

      return productJSON;
    }
  }
  
  customElements.define("predictive-search", PredictiveSearch);
}